import Handsontable from "handsontable";
import "./../../Pages/Users/Create_User/CreateUser.css"

export function firstnameRender(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.BaseRenderer.apply(this, arguments);
    if (prop === "first_name") {
        let rowData = cellProperties.instance.getSourceDataAtRow(
            cellProperties.instance.toPhysicalRow(row)
        );
        if (!rowData) {
            return;
        }
        else if (rowData.staffGuid != null && this.FirmLinkedToAxcess) {
            cellProperties.readOnly = true;
            cellProperties.className = "wkusergriddisabled"
        }
        let isLocked = rowData.is_locked && rowData.is_locked === "Y"
            ? "<i aria-hidden='true' class='large icon xcm-icon-lock'></i>"
            : "";
        td.innerHTML =
            "<a href='edituser/" +
            window.btoa(rowData.user_id) +
            "/edit' >" +
            isLocked +
            value +
            "  </a>";
    }
    if (prop === "firstName") {        
        let rowData = cellProperties.instance.getSourceDataAtRow(
            cellProperties.instance.toPhysicalRow(row)
        );
        if (!rowData) {
            return;
        }
        else if (rowData.staffGuid != null && this.FirmLinkedToAxcess) {
            cellProperties.readOnly = true;
            cellProperties.className = "wkusergriddisabled"
        }
        let isLocked = rowData.is_locked && rowData.is_locked === "Y"
            ? "<i aria-hidden='true' class='large icon xcm-icon-lock'></i>"
            : "";
        td.innerHTML =
            "<a href='edituser/" +
            window.btoa(rowData.xcm_UserId) +
            "/edit' >" +
            isLocked +
            value +
            "  </a>";
    }
}
export function phoneRender(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.BaseRenderer.apply(this, arguments);
    if (prop === "phone_number") {
        let rowData = cellProperties.instance.getSourceDataAtRow(
            cellProperties.instance.toPhysicalRow(row)
        );
        if (!rowData) {
            return;
        }
        else if (rowData.staffGuid != null && this.FirmLinkedToAxcess) {
            cellProperties.readOnly = true;
            cellProperties.className = "wkusergriddisabled"
        }
        Handsontable.cellTypes.text.renderer(
            instance,
            td,
            row,
            col,
            prop,
            value,
            cellProperties
        );
    }

}
export function disableRender(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.BaseRenderer.apply(this, arguments);
    let rowData = cellProperties.instance.getSourceDataAtRow(
        cellProperties.instance.toPhysicalRow(row)
    );
    if (!rowData) {
        return;
    }
    else if (rowData.staffGuid != null && this.FirmLinkedToAxcess) {
        cellProperties.readOnly = true;
        cellProperties.className = "wkusergriddisabled"
    }
    Handsontable.cellTypes.text.renderer(
        instance,
        td,
        row,
        col,
        prop,
        value,
        cellProperties
    );
}

export function customDropdownRenderer_DisableCheck(instance, td, row, col, prop, value, cellProperties) {
    let rowData = cellProperties.instance.getSourceDataAtRow(
        cellProperties.instance.toPhysicalRow(row)
    );
    if (!rowData) {
        return;
    }
    else if (rowData.staffGuid != null && this.FirmLinkedToAxcess) {
        cellProperties.readOnly = true;
        cellProperties.className = "wkusergriddisabled"
    }

    var optionsList = cellProperties.selectOptions.data;
    if (
        typeof optionsList === "undefined" ||
        typeof optionsList.length === "undefined" ||
        !optionsList.length ||
        !value
    ) {
        Handsontable.cellTypes.text.renderer(
            instance,
            td,
            row,
            col,
            prop,
            value,
            cellProperties
        );
        return td;
    }
    var values =
        typeof value == "string"
            ? value.split("|").map(i => (typeof i == "string" ? i.trim() : i))
            : value;

    value = values.filter(v => v !== "").join(", ");
    Handsontable.cellTypes.text.renderer(
        instance,
        td,
        row,
        col,
        prop,
        value,
        cellProperties
    );

    return td;
}